import { AbstractControl, ValidationErrors } from '@angular/forms';

export function isValidMobileNumber(value: string) {
  return /^(?:0|94|0094|\+94)[0-9]{9}$/.test(value);
}

export const mobileNumberValidator = (control: AbstractControl): ValidationErrors | null => {
  if (!control.value) return null;
  return isValidMobileNumber(control.value) ? null : { invalidMobile: true };
}; 